import { AddGroupMemberScreenNavigationProps } from "./types"
import React from "react"
import AddGroupMember from "./add-group-member-screen"
import { PageRoot } from "~screens/page-root"


const AddGroupChatScreen: React.FC<AddGroupMemberScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <AddGroupMember />
    </PageRoot>
  )
}

export default AddGroupChatScreen
